export default "__VITE_ASSET__KyTRieHu__"